import { render, staticRenderFns } from "./ComponentPlayground.vue?vue&type=template&id=340e98b4&scoped=true&"
import script from "./ComponentPlayground.vue?vue&type=script&lang=ts&"
export * from "./ComponentPlayground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340e98b4",
  null
  
)

export default component.exports